export const BH_POSTA = 'bhPosta';
export const POSTE_SRPSKE = 'posteSrpske';
export const MILSPED = 'milsped';
export const X_EXPRESS = 'xExspress';
export const EURO_EXPRESS = 'euroexpress';
export const TRANSFERA = 'transfera';
